import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

import { LastRefundsInfoCard } from 'components/ItemInfoCard';
import { translate } from 'helpers/intl';
import messages from 'containers/AMCDashboard/LastRefunds/messages';
import { StyledSmallSectionHeader } from 'containers/AMCDashboard/MyContracts/styles';
import { uppercase } from 'utils/string';
import {
  useStyles,
  StyledGrid,
  StyledCard,
  COLOR_BY_REFUND_STATUS,
} from 'containers/AMCDashboard/LastRefunds/styles';
import ItemEmptyState from 'components/ItemEmptyState';
import pages from 'routes/pages';

const LastRefunds = ({
  lastRefund,
  refundDetails,
  setDetailsPageBreadcrumbsPath,
  ...otherProps
}: {
  intl: IntlShape;
  lastRefund: any;
  refundDetails: any;
  setDetailsPageBreadcrumbsPath: Function;
}) => {
  const classes = useStyles();

  return (
    <>
      <StyledSmallSectionHeader>
        {translate({ ...messages.title }, otherProps)}
      </StyledSmallSectionHeader>
      {lastRefund ? (
        <LastRefundsInfoCard
          styles={{ buttonRootStyles: classes.root }}
          firstInformationLabel={translate({ ...messages.amount }, otherProps)}
          secondInformationLabel={translate(
            { ...messages.lossDate },
            otherProps,
          )}
          firstInformationValue={refundDetails.montantRegle}
          secondInformationValue={refundDetails.dateSurvenance}
          buttonLabel={uppercase(
            translate({ ...messages.seeDetails }, otherProps),
          )}
          status={COLOR_BY_REFUND_STATUS[lastRefund.statusApplication]}
          statusLabel={lastRefund.statusApplication}
          title={`${uppercase(
            translate({ ...messages.claimNumber }, otherProps),
          )} ${lastRefund.numeroApplication}`}
          redirectionPath={pages.AMC_DETAILS}
          setDetailsPageBreadcrumbsPath={setDetailsPageBreadcrumbsPath}
        />
      ) : (
        <StyledCard>
          <StyledGrid
            container
            textAlign="center"
            alignItems="center"
            justify="center"
            marginBottom="17px"
          >
            <ItemEmptyState
              label={translate({ ...messages.emptyState }, otherProps)}
            />
          </StyledGrid>
        </StyledCard>
      )}
    </>
  );
};

export default injectIntl(LastRefunds);
